module.exports = __webpack_public_path__ + "static/assets/c56dfc57ba7eab324fed5cd72a0d92c9.png";